import { render } from "./DTButton.vue?vue&type=template&id=fd0fef26&scoped=true"
import script from "./DTButton.vue?vue&type=script&lang=js"
export * from "./DTButton.vue?vue&type=script&lang=js"

import "./DTButton.vue?vue&type=style&index=0&id=fd0fef26&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0fef26"]])

export default __exports__